import { render, staticRenderFns } from "./impersonate.vue?vue&type=template&id=cd22048e&scoped=true"
import script from "./impersonate.vue?vue&type=script&lang=js"
export * from "./impersonate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd22048e",
  null
  
)

export default component.exports